import React, { useCallback, useEffect, useState } from 'react'
import { Button, Container, Header, Message } from 'semantic-ui-react'
import { getApiGatewayClient } from "services/api";

import * as AccountService from 'services/accounts'
import * as AccountsTable from 'components/Admin/Accounts/AccountsTable'
import * as AccountsTableColumns from 'components/Admin/Accounts/AccountsTableColumns'
import * as MessageList from "components/MessageList";

const UnconfirmedUsers = () => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedAccount, setSelectedAccount] = useState(undefined);
  const [messages, setMessage] = MessageList.useMessages();

  const getUnconfirmedUsers = () => {
    AccountService.fetchUnconfirmedAccounts()
      .then(accounts => setAccounts(accounts))
      .catch(err => {
        console.log(err)
        const errMsg = `Endpoint: ${err.config.url}; status code: ${err.status} ${err.statusText}`;
        setMessage((dismiss) => (
          <ErrorMessage errorMessage={errMsg} dismiss={dismiss} />
        ))
      }).finally(() => setLoading(false));
  }

  useEffect(() => {
    getUnconfirmedUsers();
  }, [])

  const onSelectAccount = useCallback(account => setSelectedAccount(account), [
    setSelectedAccount,
  ])

  const onRemoveAccount = useCallback(async () => {
    setLoading(true);
    const response = await getApiGatewayClient("/admin/developer", {
      operation: "deleteUnConfirmedAccount",
      payload: {
        Username: selectedAccount.Username
      },
    })

    if (response.success) {
      getUnconfirmedUsers();
      setMessage((dismiss) => (
        <DeleteSuccessMessage account={selectedAccount} dismiss={dismiss} />
      ));
      return;
    }

    setMessage((dismiss) => (
      <DeleteFailureMessage account={selectedAccount} dismiss={dismiss} />
    ));
    setLoading(false);
  }, [selectedAccount, setMessage])

  return (
    <Container fluid style={{ padding: '2em' }}>
      <Header as='h1'>Unconfirmed accounts</Header>
      <MessageList.MessageList messages={messages} />
      <AccountsTable.AccountsTable
        accounts={accounts}
        isShowFilter={false}
        sortOrder={
          {
            column: AccountsTableColumns.DateCreated,
            directionIndex: 2,
          }
        }
        columns={[
          AccountsTableColumns.Email,
          AccountsTableColumns.DateCreated,
        ]}
        loading={loading}
        selectedAccount={selectedAccount}
        onSelectAccount={onSelectAccount}
      >
        <TableActions
          canDelete={!loading && selectedAccount}
          onRemoveAccount={onRemoveAccount}
        />
      </AccountsTable.AccountsTable>
    </Container>
  )
}

export default UnconfirmedUsers;

const TableActions = React.memo(
  ({ canDelete, onRemoveAccount }) => (
    <Button.Group>
      <Button
        content="Delete"
        disabled={!canDelete}
        onClick={onRemoveAccount}
      />
    </Button.Group>
  )
);

const DeleteSuccessMessage = React.memo(({ account, dismiss }) => (
  <Message onDismiss={dismiss} positive>
    <Message.Content>
      Deleted account <strong>{account.Attributes.filter(attr => attr.Name === 'email')[0].Value}</strong>.
    </Message.Content>
  </Message>
));

const DeleteFailureMessage = React.memo(
  ({ account, errorMessage, dismiss }) => (
    <Message onDismiss={dismiss} negative>
      <Message.Content>
        <p>
          Failed to delete account <strong>{account.Attributes.filter(attr => attr.Name === 'email')[0].Value}</strong>.
        </p>
        {errorMessage && <p>Error message: {errorMessage}</p>}
      </Message.Content>
    </Message>
  )
);

const ErrorMessage = React.memo(({ errorMessage, dismiss }) => (
  <Message onDismiss={dismiss} negative>
    <Message.Content>
      {errorMessage}
    </Message.Content>
  </Message>
));
